import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/components/site/seo-copy";
import SectorsView from "@/components/cl/views/SectorsView";

export const Route = createFileRoute("/sectors")({
  head: () => pageHead("/sectors"),
  component: SectorsView,
});
